import { Component } from '@angular/core';

@Component({
  selector: 'app-cards11-examples-74',
  templateUrl: './cards11-examples-74.component.html'
})
export class Cards11Examples74Component {}
